import React from 'react';
import { Modal, ModalFooter, Button } from 'reactstrap';
import MfaModal from '../settings/mfaModal';
import '../settings/mfaModal.css';

function ForceMfaModal(props) {
    return (
        <Modal
            className="mfa-modal-main"
            isOpen={props.isOpen}
            toggle={props.onCancel}
            backdrop="static"
        >
            <MfaModal
                userData={props.userData}
                getUserData={props.onSuccess}
                mfaBtnOnClick={props.onSuccess}
            />
            <ModalFooter className="justify-content-center">
                <Button color="secondary" onClick={props.onCancel}>
                    Cancel &amp; Logout
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default ForceMfaModal;
